<template>
  <div>
    <v-autocomplete
      ref="autocomplete"
      v-model="model"
      :items="items"
      :loading="isLoading"
      :search-input.sync="search"
      clearable
      no-filter
      :height="(multiple ? (model && model.length > 1 ? 'auto' : 32) : '32')"
      :hide-details="(rules ? false : true)"
      :return-object="(filter ? false : true)"
      item-text="name"
      :rules="(rules ? rules : [])"
      :required="(rules ? true : false)"
      item-value="id"
      :label="$t(title)"
      :dense="(multiple ? (model && model.length > 1 ? false : true) : true)"
      :chips="(multiple ? multiple : null)"
      :multiple="(multiple ? multiple : null)"
      :filled="(filled ? filled : false)"
      :flat="(flat ? flat : false)"
      :solo="(solo ? solo : false)"
      :disabled="disabled"
      :outlined="(outlined ? outlined : true)"
      :menu-props="{
        maxHeight: (isMobile ? 0 : 200),
        nudgeWidth: 0,
      }"
      @blur="$emit('blur')"
      @click="openMobileDialog"
      @click:clear="onclear"
      @change="$emit('change')"
    >
      <template v-slot:append>
        <v-slide-x-reverse-transition
          mode="out-in"
        >
          <v-icon
            :key="`icon-${appendIcon}`"
            :color="notFind ? 'success' : 'secondary'"
            tabindex="-1"
            @click="appendIcon = !appendIcon"
            v-text="notFind ? 'mdi-check-outline' : 'mdi-chevron-down'"
          />
        </v-slide-x-reverse-transition>
      </template>
      <template v-slot:no-data>
        <!--        <v-list-item>-->
        <!--          <v-list-item-content>-->
        <!--            <v-list-item-title v-text="search" />-->
        <!--            <v-list-item-subtitle>{{ $t('no-data') }}</v-list-item-subtitle>-->
        <!--          </v-list-item-content>-->
        <!--          <v-list-item-action>-->
        <!--            <v-icon color="success">-->
        <!--              mdi-check-outline-->
        <!--            </v-icon>-->
        <!--          </v-list-item-action>-->
        <!--        </v-list-item>-->
      </template>
      <template
        v-if="!multiple"
        v-slot:selection="{item}"
      >
        <span v-text="item.name" />
      </template>
      <template
        v-if="multiple"
        v-slot:selection="{item, index}"
      >
        <v-chip
          v-if="index < 2"
          close
          small
          dark
          :color="(item.color ? item.color : 'primary')"
          class="my-1"
          @click:close="remove(item)"
        >
          {{ item.name }}
        </v-chip>
        <v-chip
          v-if="model.length > 2 && index === 1"
          small
        >
          <span>(+{{ model.length - 2 }} {{ $t('otherItems') }})</span>
        </v-chip>
      </template>
      <template
        v-slot:append
      >
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-if="append"
              color="primary"
              v-bind="attrs"
              icon
              small
              style="margin: 0px !important;margin-top: -3px !important;"
              v-on="on"
              @click="setDefault"
            >
              <v-icon
                medium
              >
                mdi-account-check-outline
              </v-icon>
            </v-btn>
          </template>
          <span>{{ $t('set-to-default') }}</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-show="$store.state.permissions && $store.state.permissions.includes('customer') && newBtn && (type === 'person' || type === 'getAllPersonOffline')"
              color="primary"
              v-bind="attrs"
              icon
              small
              style="margin: 0px !important;margin-top: -3px !important;"
              tabindex="-1"
              v-on="on"
              @click.stop.prevent="accountDialog = true"
            >
              <v-icon
                medium
              >
                mdi-account-plus-outline
              </v-icon>
            </v-btn>
          </template>
          <span>{{ $t('new-account') }}</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-if="$store.state.permissions && $store.state.permissions.includes('Product') && (newBtn && type === 'product'|| newBtn && type === 'productService')"
              color="primary"
              v-bind="attrs"
              icon
              small
              style="margin: 0px !important;margin-top: -3px !important;"
              tabindex="-1"
              v-on="on"
              @click.stop.prevent="productDialog = true"
            >
              <v-icon
                medium
              >
                mdi-plus
              </v-icon>
            </v-btn>
          </template>
          <span>{{ $t('product') }}</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-if="newBtn && type === 'product' || newBtn && type === 'productService'"
              color="primary"
              v-bind="attrs"
              icon
              small
              style="margin: 0px !important;margin-top: -3px !important;"
              tabindex="-1"
              v-on="on"
              @click.stop.prevent="barcodeDialog = true"
            >
              <v-icon
                medium
              >
                mdi-barcode-scan
              </v-icon>
            </v-btn>
          </template>
          <span>{{ $t('product') }}</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-if="newBtn && type === 'given'"
              color="primary"
              v-bind="attrs"
              icon
              small
              style="margin: 0px !important;margin-top: -3px !important;"
              tabindex="-1"
              v-on="on"
              @click.stop.prevent="givenDialog = true"
            >
              <v-icon
                medium
              >
                mdi-plus
              </v-icon>
            </v-btn>
          </template>
          <span>{{ $t('given') }}</span>
        </v-tooltip>
      </template>
      <template v-slot:append-item>
        <div
          v-if="items && items.length !== 0 && last_page > 1 && last_page >= page "
          v-observe-visibility="{
            callback: visibilityChanged
          }"
          class="text-center"
        >
          <v-progress-circular
            :size="20"
            :width="2"
            color="primary"
            indeterminate
          />
        </div>
      </template>
      <template v-slot:prepend-item>
        <div
          v-if="newBtn && type === 'detail'"
          style="border-radius: 5px;border: 1px solid #e3e3e3;margin: 5px"
        >
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="primary"
                v-bind="attrs"
                small
                icon
                tabindex="-1"
                v-on="on"
                @click.stop.prevent="detailDialog = true"
              >
                <v-icon
                  medium
                >
                  mdi-playlist-plus
                </v-icon>
              </v-btn>
            </template>
            <span>{{ $t('newdetail') }}</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="primary"
                v-bind="attrs"
                small
                icon
                tabindex="-1"
                v-on="on"
                @click.stop.prevent="accountDialog = true"
              >
                <v-icon
                  medium
                >
                  mdi-account-plus-outline
                </v-icon>
              </v-btn>
            </template>
            <span>{{ $t('new-account') }}</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="primary"
                v-bind="attrs"
                small
                icon
                tabindex="-1"
                v-on="on"
                @click.stop.prevent="productDialog = true"
              >
                <v-icon
                  medium
                >
                  mdi-package-variant
                </v-icon>
              </v-btn>
            </template>
            <span>{{ $t('new-product') }}</span>
          </v-tooltip>
        </div>
      </template>
      <template v-slot:item="{ item }">
        <v-list-item-content>
          <v-list-item-title
            class="text-wrap"
            v-text="item.name"
          />
          <!--        <v-list-item-subtitle v-text="item.symbol" />-->
        </v-list-item-content>
        <v-list-item-action>
          <v-icon v-if="type== 'person'">
            mdi-account
          </v-icon>
          <v-chip
            v-if="type !== 'detail' && item.label "
            class="mx-0"
            :color="(item.color ? item.color : 'primary')"
            label
            x-small
            outlined
          >
            {{ $t(item.label) }}
          </v-chip>
        </v-list-item-action>
      </template>
    </v-autocomplete>
    <v-dialog
      v-model="mobileDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-app-bar
          fixed
          color="primary"
          elevation="4"
          class="px-3"
        >
          <v-app-bar-nav-icon>
            <v-btn
              icon
              dark
              @click="mobileDialog = false"
            >
              <v-icon
                color="white"
                style="font-size: 20px"
              >
                mdi-close
              </v-icon>
            </v-btn>
          </v-app-bar-nav-icon>
          <v-toolbar-title style="color: white">
            {{ $t(title) }}
          </v-toolbar-title>
          <v-spacer />
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-if="append"
                color="primary"
                v-bind="attrs"
                icon
                small
                style="margin: 0px !important;margin-top: -3px !important;"
                v-on="on"
                @click="setDefault"
              >
                <v-icon color="white">
                  mdi-account-check-outline
                </v-icon>
              </v-btn>
            </template>
            <span>{{ $t('set-to-default') }}</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-show="$store.state.permissions && $store.state.permissions.includes('customer') && newBtn && (type === 'person' || type === 'getAllPersonOffline')"
                color="white"
                v-bind="attrs"
                icon
                tabindex="-1"
                v-on="on"
                @click.stop.prevent="accountDialog = true"
              >
                <v-icon
                  style="font-size: 26px"
                  color="white"
                >
                  mdi-account-plus-outline
                </v-icon>
              </v-btn>
            </template>
            <span>{{ $t('new-account') }}</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-if="$store.state.permissions && $store.state.permissions.includes('Product') && (newBtn && type === 'product'|| newBtn && type === 'productService')"
                color="primary"
                v-bind="attrs"
                icon
                small
                style="margin: 0px !important;margin-top: -3px !important;"
                tabindex="-1"
                v-on="on"
                @click.stop.prevent="productDialog = true"
              >
                <v-icon
                  medium
                  color="white"
                >
                  mdi-plus
                </v-icon>
              </v-btn>
            </template>
            <span>{{ $t('product') }}</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-if="newBtn && type === 'product' || newBtn && type === 'productService'"
                color="primary"
                v-bind="attrs"
                icon
                small
                style="margin: 0px !important;margin-top: -3px !important;"
                tabindex="-1"
                v-on="on"
                @click.stop.prevent="barcodeDialog = true"
              >
                <v-icon
                  medium
                  color="white"
                >
                  mdi-barcode-scan
                </v-icon>
              </v-btn>
            </template>
            <span>{{ $t('product') }}</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-if="newBtn && type === 'given'"
                color="primary"
                v-bind="attrs"
                icon
                small
                style="margin: 0px !important;margin-top: -3px !important;"
                tabindex="-1"
                v-on="on"
                @click.stop.prevent="givenDialog = true"
              >
                <v-icon
                  medium
                  color="white"
                >
                  mdi-plus
                </v-icon>
              </v-btn>
            </template>
            <span>{{ $t('given') }}</span>
          </v-tooltip>
          <template v-slot:extension>
            <div
              style="width: 100%;padding-top: 10px"
            >
              <v-text-field
                v-model="mobileSearch"
                :label="$t('search')"
                solo
                flat
                :loading="isLoading"
                height="45"
                clearable
              >
                <template v-slot:append>
                  <v-fade-transition leave-absolute>
                    <v-progress-circular
                      v-if="isLoading"
                      size="24"
                      color="green"
                      indeterminate
                    />
                  </v-fade-transition>
                </template>
              </v-text-field>
            </div>
          </template>
        </v-app-bar>
        <v-list style="margin-top: 98px">
          <!--          <v-subheader>REPORTS</v-subheader>-->
          <v-list-item-group
            v-model="mobileModel"
            color="primary"
            :multiple="(multiple ? multiple : null)"
            style="overflow-y: scroll;overflow-x: hidden;min-height: 400px;"
          >
            <v-list-item
              v-for="(item, index) in mobileItems"
              :key="index"
              :value="item"
              class="data-table-list-items px-0"
              :class="{
                'mobile-td-list-border-primary': (!item.remain || item.remain && item.remain.remain == 0 ? true : false ),
                'mobile-td-list-border-red': (item.remain && item.remain.remain > 0 ? true : false ),
                'mobile-td-list-border-green': (item.remain && item.remain.remain < 0 ? true : false ),
              }"
              elevation="4"
            >
              <v-list-item-icon class="ps-2 me-1">
                <p class="mt-1">
                  {{ +index + +1 }}
                </p>
              </v-list-item-icon>
              <v-list-item-content class="ms-3">
                <v-list-item-title class="text-wrap">
                  {{ item.name }}
                </v-list-item-title>
                <v-list-item-subtitle
                  v-if="type === 'person'"
                  class="text-wrap mt-1"
                >
                  <a
                    v-if="item.phone"
                    style="font-size: 14px"
                  >
                    {{ $t('phone') }} : {{ item.phone }}
                  </a>
                  <a
                    v-if="item.mobile && type === 'person'"
                    style="font-size: 14px"
                    class="mt-1"
                  >
                    {{ $t('mobile') }} : {{ item.mobile }}
                  </a>
                </v-list-item-subtitle>
                <v-list-item-subtitle
                  v-if="item.email && type === 'person'"
                  class="text-wrap"
                  style="font-size: 14px !important;"
                >
                  {{ $t('email') }} : {{ item.email }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item class="justify-center">
              <div
                v-if="mobileItems && mobileItems.length !== 0 && last_page > 1 && last_page >= page"
                v-observe-visibility="{
                  callback: visibilityChanged
                }"
                width="100%"
                height="40px"
                class="d-flex my-0 pa-2"
              >
                <v-progress-circular
                  :size="20"
                  :width="2"
                  color="primary"
                  indeterminate
                />
              </div>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="accountDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="95%"
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-col class="d-flex pt-2 pb-0">
          <v-btn
            icon
            @click="accountDialog = false"
          >
            <v-icon
              class="close-hover"
              color="grey"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t('new-account') }}
          </p>
        </v-col>
        <v-card-text class="pa-0">
          <div
            class="overflow-y-auto ma-2 mt-0"
            style=" height: auto"
          >
            <customer
              v-model="newAccount"
              :return-object="true"
              @close="accountDialog = false"
            />
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="givenDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="95%"
    >
      <v-card>
        <v-col class="d-flex pt-2 pb-0">
          <v-btn
            icon
            @click="givenDialog = false"
          >
            <v-icon
              class="close-hover"
              color="grey"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t('accountStracture') }}
          </p>
        </v-col>
        <v-card-text class="pa-0">
          <div
            class="overflow-y-auto ma-2 mt-0"
            style=" height: 350px"
          >
            <accountingCoding
              v-model="newGiven"
              :return-object="true"
              @close="givenDialog = false"
            />
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="detailDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="95%"
    >
      <v-card>
        <v-col class="d-flex pt-2 pb-0">
          <v-btn
            icon
            @click="detailDialog = false"
          >
            <v-icon
              class="close-hover"
              color="grey"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t('accountStracture') }}
          </p>
        </v-col>
        <v-card-text class="pa-0">
          <div
            class="overflow-y-auto ma-2 mt-0"
            style=" height: 350px"
          >
            <detail
              v-model="newDetail"
              :return-object="true"
              @input="newDetail"
              @close="detailDialog = false"
            />
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="productDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="95%"
    >
      <v-card>
        <v-col class="d-flex pt-2 pb-0">
          <v-btn
            icon
            @click="productDialog = false"
          >
            <v-icon
              class="close-hover"
              large
              color="grey"
            >
              mdi-close
            </v-icon>
          </v-btn>
        </v-col>
        <v-card-text class="pa-0">
          <div
            class="overflow-y-auto ma-2 mt-0"
            style=" height: 350px"
          >
            <product
              v-model="newProduct"
              form-type="product"
              @close="productDialog = false"
            />
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="barcodeDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="440px"
    >
      <v-card>
        <v-col class="d-flex pt-2 pb-0">
          <v-btn
            icon
            @click="barcodeDialog = false"
          >
            <v-icon
              class="close-hover"
              large
              color="grey"
            >
              mdi-close
            </v-icon>
          </v-btn>
        </v-col>
        <v-card-text class="pa-0">
          <div
            class="ma-2 mt-0"
          >
            <barcode
              @decode="(a, b, c) => onDecode(a, b, c)"
              @loaded="() => onLoaded()"
            />
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
        </v-card-actions>
      </v-card>
    </v-dialog>
    <snakbar
      v-model="snackbar"
      :text="snakbarText"
      :active="snackbar"
      :color="(snakbarColor ? snakbarColor : 'primary')"
    />
  </div>
</template>

<script>
  import barcode from '../barcode/barcode'
  import customer from '../../../pages/account/customer'
  import Product from '../../../pages/product/product'
  import accountingCoding from '../../../pages/accounting/coding'
  import Detail from '../../../pages/account/detail'
  import General from '../../../../../Mixins/general'
  export default {
    name: 'Autocomplete',
    components: {
      Snakbar: () => import('../snakbar/snakbar'),
      customer,
      accountingCoding,
      Detail,
      Product,
      barcode,
    },
    mixins: [General],
    props: ['value', 'type', 'append', 'customerid', 'newBtn', 'title',
            'currencyProp', 'data', 'multiple', 'rules', 'init', 'setInit',
            'outlined', 'filled', 'solo', 'flat', 'disabled', 'parent', 'getInitItemsOff',
            'offline', 'url', 'filter', 'urlKey', 'setOffline', 'typeProp',
    ],
    data: () => ({
      showLoader: true,
      mobileDialog: false,
      barcodeText: null,
      newProduct: null,
      newGiven: null,
      mobileModel: null,
      newDetail: null,
      givenDialog: false,
      detailDialog: false,
      barcodeDialog: false,
      productDialog: false,
      accountDialog: false,
      isLastPage: false,
      isLoading: false,
      appendIcon: 'chevron-down',
      snackbar: false,
      newAccount: null,
      last_page: 1,
      currency: null,
      snakbarText: null,
      snakbarColor: null,
      text: null,
      items: [],
      id: null,
      idd: null,
      // items: Array.from(Array(10).keys()),
      model: null,
      search: null,
      page: 1,
      timer: null,
      notFind: null,
      tab: null,
      initList: null,
      mobileSearch: null,
      oldSearch: null,
      mobileItems: [],
      setInitial: false,
      searchTimeout: 0,
    }),
    watch: {
      value (val, old) {
        if (this.value) {
          this.setModel(this.value)
        } else {
          this.clear()
          this.getItems({ query: null, page: 1 })
        }
      },
      newAccount () {
        if (this.newAccount) {
          this.accountDialog = false
          if (this.type === 'detail') {
            this.newAccount.id = this.newAccount.fin_id
          }
          this.setModel(this.newAccount)
        }
      },
      newGiven () {
        if (this.newGiven) {
          this.givenDialog = false
          this.setModel(this.newGiven)
        }
      },
      newDetail () {
        if (this.newDetail) {
          this.detailDialog = false
          this.setModel(this.newDetail)
        }
      },
      newProduct () {
        if (this.newProduct) {
          this.productDialog = false
          if (this.type === 'detail') {
            this.newProduct.id = this.newProduct.fin_id
          }
          this.setModel(this.newProduct)
        }
      },
      customerid (val, oldval) {
        this.setModel(val)
      },
      mobileSearch () {
        this.page = 1
        this.setInitial = false
        this.items = []
        this.mobileItems = []
        this.getItems()
      },
      model (val) {
        if (val != null) {
          this.tab = 0
          if (this.notFind) {
            this.text = this.$t('alert-register-success')
            this.snackbar = true
          }
          this.$emit('input', this.model)
          // if (this.multiple) {
          //   this.$emit('input', this.model)
          // } else {
          //   this.$emit('input'
          //              , {
          //                showButton: true,
          //                name: val.name,
          //                id: val.id,
          //                type: val.type,
          //                code: val.code,
          //                group_id: val.group_id,
          //                remain: val.remain,
          //              })
          // }

          // if (this.id) {
          //   this.$emit('input', this.id)
          // }
        } else {
          this.tab = null
          this.$emit('input', null)
        }
      },
      search(val, oldSearch) {
        this.oldSearch = oldSearch
        var app = this;
        this.page = 1;
        this.setInitial = false;
        if (this.model && this.model.name === val) {
          return false;
        }
        clearTimeout(this.searchTimeout);
        this.searchTimeout = setTimeout(() => {
          app.items = [];
          if (app.multiple && app.model && app.model.length > 0) {
            app.items = app.model
          }
          app.getItems();
        }, 600);

      },
      currencyProp () {
        this.currency = this.currencyProp
        this.items = []
        this.page = 1
        this.initList = false
        this.getItems()
      },
      offline (val) {
        if (val) {
          this.isLoading = false
          this.loading = false
          this.getItemsOffline()
        }
      },
      setOffline (val) {
        if (val) {
          this.isLoading = false
          this.loading = false
          this.storedItemsOffline()
        }
      },
      mobileModel (val) {
        this.$emit('input', val)
        if (!this.multiple) {
          this.mobileDialog = false
        }
      },
    },
    mounted  () {
      this.setInitial = this.setInit
      if (JSON.parse(localStorage.getItem('token'))) {
        this.currency = this.$store.state.currency.id
        if (this.currencyProp) {
          this.currency = this.currencyProp
        }
      }
      if (this.value) {
        this.setModel(this.value)
      } else {
        if (this.offline) {
          this.getItemsOffline()
        }
        if (this.setOffline) {
          this.storedItemsOffline()
        } else {
          if (!this.getInitItemsOff) {
            this.getItems({ query: null, page: 1 })
          }
        }
      }
    },
    methods: {
      openMobileDialog () {
        if (this.isMobile) {
          this.mobileDialog = true
          if (this.page === 1 && this.mobileItems.length === 0) {
            this.getItems()
          }
        }
      },
      onclear () {
        this.$emit('clear')
        this.getItems()
      },
      onDecode (a, b, c) {
        if (a) {
          this.search = a
          this.barcodeDialog = false
        }
      },
      onLoaded () {
      },
      remove (item) {
        if (!this.filter) {
          var index = this.model.findIndex(x => x.id === item.id && x.type === item.type)
          if (index >= 0) this.model.splice(index, 1)
        } else {
          const i = this.model.indexOf(item.id)
          if (i >= 0) this.model.splice(i, 1)
        }
      },
      setDefault () {
        var app = this
        if (app.model) {
          app.isLoading = true
          app.$axios.get(this.$endpoint + 'getdetail', {
            params: {
              select: 'setDefaultAccount',
              id: app.model,
            },
          })
            .then(res => {
              app.$emit('snackbarShow', { text: res.data.message, color: 'green' })
            })
            .catch(err => {
              this.serverErrorHandeler(err)
            })
            .finally(() => (app.isLoading = false))
        }
      },
      setModel (item) {
        // this.items = [item]
        var app = this
        if (this.multiple) {
          app.items = [
            ...app.items,
            ...Array.from(item),
          ]
          this.search = null
        } else {
          this.items.push(item)
        }
        this.model = item
        this.id = item
      },
      clear () {
        this.items = []
        this.model = null
      },
      visibilityChanged (e) {
        e && this.getItems()
      },
      getItems () {
        this.loading = true
        if (this.offline) {
          this.getItemsOffline()
          return false
        }
        if (this.page === 1 && this.search == null && this.initList && !this.isMobile) {
          return false
        }
        this.initList = true
        var app = this
        app.isLoading = true
        var url = app.$endpoint + 'getdetail'
        if (app.url) {
          url = app.$apipoint + 'getcurrency'
        }
        if (this.urlKey) {
          app.$axios.defaults.headers.common.abr_key = this.urlKey
        }
        clearTimeout(app.timer)
        app.timer = setTimeout(function () {
          app.$axios.get(url + '?select=' + app.type + '&search=' + (app.isMobile ? app.mobileSearch : app.search) + '&page=' + app.page + '&currency=' + app.currency + '&data=' + app.data + '&parent_id=' + app.parent + '&formType=' + app.typeProp)
            .then(res => {
              res = res.data
              if (app.search && !app.value && app.page === 1) {
                app.items = []
              }
              var setDef = false
              if (app.setOffline) {
                app.insertOffline(res.data)
              }
              if (app.setInitial && app.page === 1) {
                setDef = true
              }
              app.last_page = res.last_page
              if (res.last_page >= app.page) {
                app.page++
              }

              if (!app.isMobile) {
                if (app.search && app.search !== app.oldSearch && app.items && app.items.length > 0 && app.page == 1) {
                  app.items = Array.from(res.data)
                } else {
                  app.items = [
                    ...app.items,
                    ...Array.from(res.data),
                  ]
                }
              } else {
                app.mobileItems = [
                  ...app.mobileItems,
                  ...Array.from(res.data),
                ]
              }
              if (setDef) {
                if (!app.isMobile) {
                  app.model = app.items[0]
                } else {
                  app.mobileModel = app.mobileItems[0]
                }
              }
              if (res.data.length > 0) {
                app.notFind = null
              } else {
              }
            })
            .catch(err => {
              app.serverErrorHandeler(err)
            })
            .finally(() => (app.isLoading = false))
        }, 0)
        this.loading = false
      },
      storedItemsOffline () {
        var app = this
        var url = app.$endpoint + 'getdetail'
        if (app.url) {
          url = app.$apipoint + 'getcurrency'
        }
        if (this.urlKey) {
          app.$axios.defaults.headers.common.abr_key = this.urlKey
        }
        clearTimeout(app.timer)
        app.timer = setTimeout(function () {
          app.$axios.get(url + '?select=' + app.type + '&search=' + app.search + '&page=' + app.page + '&currency=' + app.currency + '&data=' + app.data + '&parent_id=' + app.parent)
            .then(res => {
              res = res.data
              if (!res.data || res.data === undefined) {
                app.insertOffline(res)
              } else {
                app.insertOffline(res.data)
              }
              app.getItemsOffline()
            })
            .catch(err => {
              app.serverErrorHandeler(err)
            })
            .finally(() => (app.isLoading = false))
        }, 50)
        this.loading = false
      },
      getItemsOffline () {
        var list = JSON.parse(localStorage.getItem(this.type))
        var app = this
        if (app.search) {
          list = list.filter(function (list) {
            if (app.type === 'getAllPersonOffline') {
              return list.name.includes(app.search) || list.code === app.search || list.phone === app.search || list.mobile === app.search
            } else {
              return list.name.includes(app.search) || list.code === app.search
            }
          })
        }
        if (list) {
          this.items = list
        } else {
          this.items = []
        }
        if (this.setInit) {
          app.model = app.items[0]
        }
      },
      insertOffline (items) {
        var type = this.type
        localStorage.setItem(type, JSON.stringify(items))
      },
    },
  }
</script>

<style scoped>
  .v-progress-circular {
    margin: 4px;
  }
</style>
